<script>
import { getDates } from '@/services/DateServices';
import { getOneReasonFromDbase, updateReason, deleteReason } from '@/services/ReasonsServices';
import { isUserLoggedIn } from "@/services/UserServices";

export default {
  props: ['id'],
  data() {
    return {
      uId: null,
      token: null,
      todayActual: null,

      reason: null,
      order: null,
      dateCreated: null,
      dateUpdated: null,
    };
  },
  methods: {
    async getTheReason() {
      const r = await getOneReasonFromDbase(this.uId, this.token, this.id);
      if (r) {
        this.reason = r.reason;
        this.order = r.order ? r.order : r.dateCreated;
        this.dateCreated = r.dateCreated;
        this.dateUpdated = r.dateUpdated;
      }

    },
    async updateReason() {
      const success = await updateReason(this.uId, this.token, this.todayActual, this.id, this.reason.trim(), this.order);
      if (success) {
        this.$router.push('/account');
      }
    },
    async deleteReason() {
      await deleteReason(this.uId, this.token, this.id);
      this.$router.push('/account');
    },
    cancel() {
      this.$router.push('/account');
    },
  },
  async created() {
    // if user is not logged in, then redirect to /
    if (!isUserLoggedIn()) {
      this.$router.push('/');
    }

    this.$cookies.set('lastViewedTab', 'reasons');

    // get const's
    this.uId = localStorage.getItem('uId');
    this.token = localStorage.getItem('idToken');
    const ta = getDates();
    this.todayActual = ta.todayActual;

    // get the reason
    await this.getTheReason();
  },
};
</script>

<template>
  <div id="edit-reason" class="px-4">
    <div class="text-h5 my-3 font-weight-bold">Edit Reason</div>

    <div v-if="!!reason">
      <v-form
        @submit.prevent="updateReason" 
        density="compact"
        class="mt-8 mb-14"
      >
        <v-text-field
          v-model="order"
          label="Order"
          variant="outlined"
          bg-color="white"
        ></v-text-field>
        <v-textarea
          v-model="reason"
          label="Your Reason Why"
          variant="outlined"
          bg-color="white"
          rows="3"
          auto-grow
        ></v-textarea>
        <div class="text-subtitle-2">Created on: {{ dateCreated }}</div>
        <div class="text-subtitle-2 mb-4">Last updated on: {{ dateUpdated }}</div>
        <v-btn type="submit" block class="bg-green text-white">
          Update Reason
        </v-btn>
      </v-form>
      <div class="d-flex justify-space-between">
        <v-btn @click.prevent="cancel" class="bg-grey">Cancel</v-btn>
        <v-btn @click.prevent="deleteReason" class="bg-red text-white">Delete Reason</v-btn>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#edit-reason {
  @media screen and (min-width: 768px) {
    padding-left: 0;
    padding-right: 0;
    margin: 0 auto;
    width: 600px;
    max-width: 600px;
  }
}
</style>

